export const SNIPPET_SERVER_URL = process.env.REACT_APP_SNIPPET_SERVER_URL;

export const DEFAULT_PRICING_CUSTOM_CSS = `.pricewell-plan {

}

.pricewell-plan-header {
  
}

.pricewell-plan-name {
  
}

.pricewell-plan-price {
  
}

.pricewell-plan-price-amount {
    
}

.pricewell-plan-price-discount {
    
}

.pricewell-plan-frequency {
  
}

.pricewell-plan-description {
  
}

.pricewell-plan-action {
  
}

.pricewell-plan-feature {
  
}
.pricewell-frequency {
    
}
.pricewell-active-frequency {

}
.pricewell-addon {
    
}`;

export const DEFAULT_PORTAL_CUSTOM_CSS = `.pricewell-customerportal-container {

}

.pricewell-customerportal-button {

}

.pricewell-customerportal-message {

}`;
